import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    deleteWorkflowPhoneNumbers,
    DeleteWorkflowPhoneNumbersParams,
    DeleteWorkflowPhoneNumbersResult,
} from 'services/api/deleteWorkflowPhoneNumbers';
import { queryKeys } from '../queryKeys';

export const useDeleteWorkflowPhoneNumbers = () => {
    const queryClient = useQueryClient();

    const { mutateAsync, isPending } = useMutation<
        DeleteWorkflowPhoneNumbersResult,
        unknown,
        DeleteWorkflowPhoneNumbersParams
    >({
        mutationFn: deleteWorkflowPhoneNumbers,
        onSuccess: (_result, { workflowId }) => {
            // Partial key match covers every page and page size of this workflow's list.
            queryClient.invalidateQueries({ queryKey: queryKeys.workflowPhoneNumbers({ workflowId }) });
        },
    });

    return { deleteWorkflowPhoneNumbers: mutateAsync, isDeletingWorkflowPhoneNumbers: isPending };
};
